import Sectors from './Sectors';

export default Sectors;
